import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import LookShop from '@/views/look_shop/index' /* 房东路由 */
import RentShop from '@/views/rent_shop/index' /* 租铺路由 */
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/20191129',
      name: 'LookShop',
      component: LookShop,
      meta: {
        title: '商铺空置、租金低？找商旺宝，海量品牌租户免费配'
      }
    },
    {
      path: '/20191130',
      name: 'RentShop',
      component: RentShop,
      meta: {
        title: '想开店，没商铺？现在找商旺宝，7天租到，年前开业赚大钱'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js